import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const separacionRoutes: Routes = [
  {
    path: 'separacion-muestras',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.SEPARACION_VER },
    loadComponent: () => import('./pages/separacion/separacion.page').then((m) => m.SeparacionPage),
    title: 'SiLabVet | Separación de muestras',
  },
  {
    path: 'separacion-muestras/:id/gestionar',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.SEPARACION_PROCESAR },
    loadComponent: () =>
      import('./pages/separacion-form/separacion-form.page').then((m) => m.SeparacionFormPage),
    title: 'SiLabVet | Revisión por muestra',
  },
];
